const utils = require('../../../lib/utils')

// TODO: model.config.isMultiPicker should respect config.relationConfig
// TODO: refresh() should respect scrollposition and search text

const defaultPlaceholderKey = 'form.fields.autoComplete.placeholderDefault'

module.exports = {
	config: {
		addNewElementsAllowed: false,
		nullAble: true,
		nullAbleIcon: 'fi fi-trash',
		showArrow: true,
		showArrowInline: false,
		showCustomActionButton: false,
		showCustomActionButtonIcon: '',
		arrowIcons: {
			closed: 'fi fi-arrow-circle-down',
			opened: 'fi fi-arrow-circle-up',
		},
		scrollOffsetStart: 44,
		orientation: 'S',
		distanceY: '3px',
	},

	model: {
		open: false,
		dataJSON: [],
		// values: {},
		// newValues: []
		// TODO: DOCS
		// TODO: model config not available after client side component refresh?!? e.g., scheduler filter form of vsb-office
		config: {
			// placeholder: '',
			placeholderKey: defaultPlaceholderKey,
		},
	},

	events: {
		click: function (event) {
			// prevent button clicks from being forwarded. mousedown is doing the job.
			event.stopImmediatePropagation()
		},
		// NOTE: mousedown does not interfere as much with focus events.
		// TODO: check if this works on mobile devices
		mousedown: function (event) {
			event.stopImmediatePropagation()
			var self = event.data.component
			var $realTarget
			var $target = $(event.target)

			if($target && $target.length > 0){
				if(($realTarget = $target.closest('button.unset')).length > 0){
					self.unChoose()
				}
				else if(($realTarget = $target.closest('button.add')).length > 0){
					self.addNewElement(self.model.$filterField.val())
				}
				else if(($realTarget = $target.closest('button.custom')).length > 0){
					self.customAction()
				}
				else if(($realTarget = $target.closest('li')).length > 0 && $realTarget.closest('.optionList').length > 0){
					if(self.model.config.isMultiPicker && $realTarget.hasClass('selected')){
						self.unChoose($realTarget.data('index'))
					} else {
						self.choose($realTarget.data('index'))
					}
				}
				else if(self.model.config.isMultiPicker && ($realTarget = $target.closest('.bubble')).length > 0){
					self.unChoose($realTarget.data('index'))
				}
				else if($target.closest('.optionList').length <= 0) {
					self.toggle()
				}
			}
		},

		change: function (event) {
			// prevent default change
			event.preventDefault();
			event.stopImmediatePropagation();
		},

		select: {
			type: 'keydown',
			action: function(event){
				var self = event.data.component;

				// close
				if(event.key === 'Escape'){
					event.preventDefault();
					event.stopImmediatePropagation();

					self.close();
				}
				else {
					let validKeyFound = true;
					let offset, offsetStart;

					// arrow down
					let $activeElement;
					if(event.key === 'ArrowDown'){
						$activeElement = self.model.$optionList.find('> li.active.selected:not(.disabled)').removeClass('selected');
						if($activeElement.length <= 0){
							$activeElement = self.model.$optionList.find('> li.active:not(.disabled)').first();
						}
						else {
							do { $activeElement = $activeElement.next(); } while($activeElement.length > 0 && (!$activeElement.hasClass('active') || $activeElement.hasClass('disabled')));
							if($activeElement.length <= 0) $activeElement = self.model.$optionList.find('> li.active:not(.disabled)').first();
						}
						$activeElement.addClass('selected');

						if(!self.model.open){
							self.open()
						}

						offsetStart = self.model.$optionList.find('> li.active:not(.disabled)').first().position().top
						offset = $activeElement.position().top - offsetStart - self.config.scrollOffsetStart

						if(offset > 0){
							self.model.$optionList.scrollTop(offset)
						}
						else {
							self.model.$optionList.scrollTop(0)
						}
					}
					else if(event.key === 'ArrowUp'){
						$activeElement = self.model.$optionList.find('> li.active.selected:not(.disabled)').removeClass('selected')
						if($activeElement.length <= 0){
							$activeElement = self.model.$optionList.find('> li.active:not(.disabled)').last()
						}
						else {
							do { $activeElement = $activeElement.prev(); } while($activeElement.length > 0 && (!$activeElement.hasClass('active') || $activeElement.hasClass('disabled')));
							if($activeElement.length <= 0) $activeElement = self.model.$optionList.find('> li.active:not(.disabled)').last();
						}
						$activeElement.addClass('selected');

						if(!self.model.open){
							self.open()
						}

						offsetStart = self.model.$optionList.find('> li.active:not(.disabled)').first().position().top
						offset = $activeElement.position().top - offsetStart - self.config.scrollOffsetStart

						if(offset > 0){
							self.model.$optionList.scrollTop(offset);
						}
						else {
							self.model.$optionList.scrollTop(0);
						}
					}
					else if(event.key === 'Enter'){
						var $target;
						if(($activeElement = self.model.$optionList.find('> li.active.selected:not(.disabled)')).length > 0){
							self.choose($activeElement.data('index'));
						}
						else if(($target = $(event.target).closest('input')).length > 0){
							var $existingElement = false;
							var filterValue = $target.val();
							self.model.$optionList.find('> li').each(function(index){
								if($(this).text() == filterValue){
									$existingElement = $(this);
									return false;
								}
							});

							// existing element
							if($existingElement){
								self.choose($existingElement.data('index'));
							}
							// new element
							else if(filterValue) {
								self.addNewElement(filterValue);
							}
						}
					}
					else {
						validKeyFound = false;
					}

					if(validKeyFound){
						event.preventDefault();
						event.stopImmediatePropagation();
					}
				}
			}
		},

		filter: {
			type: 'input',
			selector: 'input',
			action: function(event){
				event.data.component.filter(event.target.value);
			}
		},

		close: {
			type: 'focusout',
			action: function (event) {
				const self = event.data.component
				let $focusTarget

				if(
					self.model.open &&
					($focusTarget = $(event.relatedTarget)).length > 0 &&
					self.$.has($focusTarget).length <= 0 &&
					!self.$.is($focusTarget)
				){
					if(self.model.keepFocusOnNextClose){
						self.model.keepFocusOnNextClose = false
						self.$.find('.filter input').focus()
					} else {
						self.close();
					}
				}
			}
		},

		openByFocus: {
			type: 'focus',
			action: function (event) {
				const self = event.data.component

				if(!self.model.open){
					self.open()
				}
			}
		},

		openByFocusInput: {
			type: 'focus',
			selector: 'input[type="text"]',
			action: function (event) {
				const self = event.data.component
				// just in case the form is tabbed in reverse order (shift-tab)
				if(!self.model.open){
					self.open()
				}
			}
		},

		openByFocusPreventionOnBubbleUsage: {
			type: 'focus',
			selector: 'div.bubbleContainer',
			action: function (event) {
				const self = event.data.component

				// keep autoComplete closed in case of a bubble removal click.
				// MARK: AUTO_COMPLETE_BUBBLE_FOCUS:  usually this would not be necessary but if the bubbleContainer would not be bound via tabIndex to a focus this would trigger the main focus otherwise and therefor open the autoCompletePicker.
				if(self.model.open){
					self.close()
				}
			}
		},
	},

	methods: {

		prepare: function(storage, isServer){
			this.model.disabled = false;
			this.model.isFilterField = false;
			if((this.formMapping || {}).fieldConfig) {
				this.model.disabled = !!this.formMapping.fieldConfig.disabled;
				this.model.isFilterField = !!this.formMapping.fieldConfig.isFilterField;
			}

			// prepare config
			const fieldConfig = this.model.config = this.model.config || {};
			this.model.disabled |= fieldConfig.disabled;
			if(fieldConfig.orientation) this.config.orientation = fieldConfig.orientation;
			if(fieldConfig.addNewElementsAllowed) this.config.addNewElementsAllowed = fieldConfig.addNewElementsAllowed;
			if(fieldConfig.nullAble !== undefined) this.config.nullAble = fieldConfig.nullAble;
			if(fieldConfig.nullAbleIcon !== undefined) this.config.nullAbleIcon = fieldConfig.nullAbleIcon;
			if(fieldConfig.showArrow !== undefined) this.config.showArrow = fieldConfig.showArrow;
			if(fieldConfig.showArrowInline !== undefined) this.config.showArrowInline = fieldConfig.showArrowInline;
			const placeholderKey = fieldConfig.placeholderKey || defaultPlaceholderKey
			if(!fieldConfig.placeholder && placeholderKey) fieldConfig.placeholder = storage.__(placeholderKey);
			if(!fieldConfig.fallbackValue){
				if(fieldConfig.placeholder) fieldConfig.fallbackValue = `<span class="placeholder">${fieldConfig.placeholder}</span>`;
				else						fieldConfig.fallbackValue = '&nbsp;';
			}

			utils.refMerge(this.config.arrowIcons, fieldConfig.arrowIcons || {})
			var renderConfig = fieldConfig.renderConfig || {};
			var childConfig = renderConfig.optionEntries || {};
			childConfig = utils.replace({ value: 'value', name: 'name', title: 'title' }, childConfig);

			// prepare langCode
			const langCode = storage.langCode

			// prepare relation config
			var isRelationField;
			var relationConfig;
			if(!!fieldConfig.relationConfig){
				isRelationField = true;
				relationConfig = fieldConfig.relationConfig;
			}

			// prepare source-data-flag
			var dataAttributeKey;
			if(!!this.model.atom && !!this.model.atom.dataType){
				dataAttributeKey = this.model.atom.dataType + '-data';
			} else {
				dataAttributeKey = 'data';
			}

			// prepare options
			this.model.options = undefined;
			if(Array.isArray(this.model[dataAttributeKey])){
				this.model.options = this.model[dataAttributeKey];
			}
			else if(!!this.model[dataAttributeKey] && !!this.model[dataAttributeKey].options){
				this.model.options = this.model[dataAttributeKey].options;
			}

			// prepare default entry
			if(renderConfig.defaultOptionEntry){
				var entry = {};
				if(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){
					entry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];
					entry[childConfig.title] = renderConfig.defaultOptionEntry.lang[langCode];
					entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
				}
				else {
					entry[childConfig.name] = renderConfig.defaultOptionEntry.name;
					entry[childConfig.title] = renderConfig.defaultOptionEntry.title || entry[childConfig.name];
					entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
				}
				this.model.options.unshift(entry);
			}

			if(this.model.options){
				var optionConfig = childConfig;
				var selectedOptionIndex;
				var defaultSelectedOptionIndex;
				var testValue;
				utils.map(this.model.options, (option, optionIndex) => {
					// define option name and title
					let optionName, optionTitle;
					if(!!option.lang && !!langCode && !!option.lang[langCode] && !!option.lang[langCode][optionConfig.name]){
						optionName = option.lang[langCode][optionConfig.name]
					} else if (!!option[optionConfig.name]) {
						optionName = option[optionConfig.name]
					} else {
						optionName = '-NO-NAME-FOUND-'
					}
					if(!!option.lang && !!langCode && !!option.lang[langCode] && !!option.lang[langCode][optionConfig.title]){
						optionTitle = option.lang[langCode][optionConfig.title]
					} else if (!!option[optionConfig.title]) {
						optionTitle = option[optionConfig.title]
					} else {
						optionTitle = optionName
					}

					if(fieldConfig.separatedFieldCodes){
						option.realValue = this.getSeparatedFieldCodeDependentValue(option)
					} else {
						option.realValue = option[optionConfig.value]
					}

					// define if option is selected
					let optionSelected = false
					let relationDataIndex
					if(isRelationField){
						if(Array.isArray(this.model.dataJSON)){
							for(relationDataIndex in this.model.dataJSON){
								if(this.model.dataJSON[relationDataIndex].attributes[relationConfig.assignedPrimaryKey] == option[optionConfig.value]){
									optionSelected = true
									break
								}
							}
						}
					} else if(Array.isArray(this.model.dataJSON)) {
						optionSelected = utils.indexOf(this.model.dataJSON, option.value) >= 0
					} else if(utils.isCollection(this.model.dataJSON) && !utils.isEmpty(fieldConfig.separatedFieldCodes)){
						optionSelected = utils.collectionMD5(this.model.dataJSON) === utils.collectionMD5(this.getSeparatedFieldCodeDependentValue(option))
					} else if(this.model.dataTEXT != undefined && this.model.atom.dataType === 'template-picker'){
						optionSelected = option[optionConfig.value] == this.model.dataTEXT
					} else {
						optionSelected = !!option.defaultSelected
					}

					if(fieldConfig.isMultiPicker){
						option.selected = optionSelected
					}
					if(optionSelected){
						selectedOptionIndex = optionIndex
					}
					option.relationDataIndex = relationDataIndex
					option.realName = optionName
					option.realTitle = optionTitle

					this.sanitizeOptionAppearance(option)

					if(fieldConfig.defaultValue){
						testValue = option.realValue;
						if(fieldConfig.defaultValueField){
							testValue = ((option.resource || {}).attributes || {})[fieldConfig.defaultValueField]
						}
						if(testValue == fieldConfig.defaultValue){
							defaultSelectedOptionIndex = optionIndex
						}
					}

					return option
				})

				if(selectedOptionIndex){
					this.model.options[selectedOptionIndex].selected = true
					this.model.selectedOption = this.model.options[selectedOptionIndex]
				} else if(defaultSelectedOptionIndex) {
					this.model.options[defaultSelectedOptionIndex].selected = true
					this.model.selectedOption = this.model.options[defaultSelectedOptionIndex]
					if(!isServer){
						this.triggerClosest('onChildChanged', {
							fieldCode: 	this.model.fieldCode,
							value: 		this.model.selectedOption.realValue
						})
					}
				}
			}
		},

		getSeparatedFieldCodeDependentValue(option){
			const fieldConfig = this.model.config || {}
			const realValue = {}
			for(const targetFieldCode in fieldConfig.separatedFieldCodes || {}){
				const sourceFieldCode = fieldConfig.separatedFieldCodes[targetFieldCode]
				// if option is null one wants to reset all separatedFieldCodes
				if(option === null){
					realValue[targetFieldCode] = null
				} else {
					realValue[targetFieldCode] = ((option.resource || {}).attributes || {})[sourceFieldCode]
				}
			}

			return realValue
		},

		open: function(){
			this.$.addClass('active')
			this.model.open = true
			this.model.$filterField.focus()
			this.model.$buttonOpen.find('i').removeClass(this.config.arrowIcons.closed).addClass(this.config.arrowIcons.opened)
		},
		close: function(){
			this.$.removeClass('active')
			this.model.$buttonOpen.find('i').removeClass(this.config.arrowIcons.opened).addClass(this.config.arrowIcons.closed)

			// EventChain: choose -> close -> blur of filter -> focus of autoCompleteField -> open via focus
			// prevent open via focus until the focus events have been triggered.
			// this happens according to the used device and / or browser before or after the used mousedown (or keydown) event which makes this ugly workaround necessary.
			setTimeout(() => {
				this.model.open = false
			}, 10)
		},
		toggle: function(){
			if(this.model.open) this.close();
			else 				this.open();
		},
		choose: function(index){
			let option = {};
			const fieldConfig = this.model.config || {}

			if(this.model.options[index]){
				option = this.model.options[index];
				this.model.selectedOption = this.model.options[index];
			}

			if(!fieldConfig.isMultiPicker){
				this.model.$optionList.find('.selected').removeClass('selected');
			}
			this.model.$optionList.find('[data-index="' + index + '"]').addClass('selected');

			let value = option.realValue
			if(fieldConfig.isMultiPicker){
				this.model.$bubbleContainer.find('[data-index="' + index + '"]').addClass('selected');
				value = this.model.dataJSON || []

				// TODO: check why index has been used for years instead of realValue!
				if(utils.indexOf(value, option.realValue) < 0){
					value.push(option.realValue)
				}
				const nrOfElements = utils.collectionSize(value)
				if(nrOfElements > 0){
					this.model.$value.html(storage.__('form.fields.autoCompleteResourcePickerMulti.nrOfChosenElements', { nrOfElements }))
					this.model.$bubbleContainer.attr('tabindex', '0')
				} else {
					this.model.$value.html(fieldConfig.fallbackValue)
					this.model.$bubbleContainer.attr('tabindex', '-1')
				}
			} else {
				this.model.$value
					.html(option.realName)
					.attr('title', option.realTitle)
					.removeAttr('class')
					.addClass(`value ${(option.additionalClasses || []).join(' ')}`)
			}

			if(fieldConfig.isMultiPicker){
				this.model.keepFocusOnNextClose = true
			}

			if(utils.isFunction(this.onChoose)){
				this.onChoose({
					fieldCode: 	this.model.fieldCode,
					value
				});
			} else {
				this.triggerClosest('onChildChanged', {
					fieldCode: 	this.model.fieldCode,
					value
				});
			}

			if(!fieldConfig.isMultiPicker) this.close();
		},
		chooseByValue: function(value){
			for(const index in this.model.options || []){
				const option = this.model.options[index]
				if(option.value == value){
					this.choose(index)
					break;
				}
			}
		},
		unChoose: function(dataIndex){
			if(
				this.config.nullAble
				&&
				(
					!utils.isEmpty(this.model.dataJSON)
					||
					this.model.selectedOption
				)
			){
				let value
				const fieldConfig = this.model.config || {}

				if(fieldConfig.isMultiPicker) {
					if(dataIndex === undefined){
						this.model.$bubbleContainer.find(`.selected`).removeClass('selected')
						for(const o in this.model.options || []){
							const option = this.model.options[o]
							option.selected = false
						}
						this.model.dataJSON = []
					} else {
						this.model.$bubbleContainer.find(`[data-index="${dataIndex}"]`).removeClass('selected')
						var option = (this.model.options || [])[dataIndex]
						if(option){
							option.selected = false
							const valueIndex = utils.indexOf(this.model.dataJSON || [], option.realValue)
							if(valueIndex >= 0){
								this.model.dataJSON.splice(valueIndex, 1)
							}
						}
					}

					value = this.model.dataJSON

					var nrOfElements = utils.collectionSize(value)
					if(nrOfElements > 0){
						this.model.$value.html(storage.__('form.fields.autoCompleteResourcePickerMulti.nrOfChosenElements', { nrOfElements }))
						this.model.$bubbleContainer.attr('tabindex', '0')
					} else {
						this.model.$value.html(fieldConfig.fallbackValue)
						this.model.$bubbleContainer.attr('tabindex', '-1')
					}
				} else {
					this.model.$value
						.html(fieldConfig.fallbackValue)
						.attr('title', '')
						.attr('class', 'value')
					this.model.dataJSON = []

					if(fieldConfig.separatedFieldCodes) {
						value = this.getSeparatedFieldCodeDependentValue(null)
					} else {
						value = null
					}
				}

				if(dataIndex === undefined){
					this.model.$optionList.find(`.selected`).removeClass('selected')
				} else {
					this.model.$optionList.find(`[data-index="${dataIndex}"]`).removeClass('selected')
				}
				if(this.model.selectedOption){
					this.model.selectedOption.selected = false;
				}
				delete this.model.selectedOption;

				if(fieldConfig.isMultiPicker){
					this.model.keepFocusOnNextClose = true
				}

				if(utils.isFunction(this.onChoose)){
					this.onChoose({
						fieldCode: 	this.model.fieldCode,
						value
					});
				} else {
					this.triggerClosest('onChildChanged', {
						fieldCode: 	this.model.fieldCode,
						value
					});
				}
				if(!fieldConfig.isMultiPicker) this.close();
			}
		},
		enable: function(){
			if(this.model.disabled){
				this.model.disabled = false;
				this.refresh(false);
			}
		},
		disable: function(){
			if(!this.model.disabled){
				this.model.disabled = true;
				this.refresh(false);
			}
		},
		filter: function(filterValue){
			var regExp = new RegExp(filterValue, 'i');
			var $element, value;
			var self = this;
			if(!filterValue && filterValue !== 0){
				self.model.$optionList.find('> li').addClass('active');
			} else {
				self.model.$optionList.find('> li').each(function(index){
					$element    = $(this);
					value       = $element.text();

					if(value == '' || value.match(regExp)){
						$element.addClass('active');
					}
					else {
						$element.removeClass('active');
					}
				});
			}
		},

		addNewElement: function(value){
			// NOTE: OVERWRITE THIS FUNCTION IF NEEDED
		},

		customAction: function(){
			// TODO: override if necessary
			console.warn('missing custom action override')
		},

		onBeforeRender(){
			// if this element will be refreshed it will be rendered closed anyway. set model.open = false to prevent needing one additional click to open the picker.
			this.model.open = false
		},

		sanitizeOptionAppearance(refOption){
			// NOTE: overwrite this method if necessary
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;

			this.parent(function(parentComponent){
				self.model.parentComponent = parentComponent;
			});
			this.model.$optionListContainer = $element.find('.optionList');
			this.model.$main = $element.find('.main');
			this.model.mainHeight = this.model.$main.outerHeight();
			this.model.$filterField = this.model.$optionListContainer.find('input');
			this.model.$optionList = this.model.$optionListContainer.find('> ul');
			this.model.$value = $element.find('.value');
			this.model.$buttonOpen = $element.find('button.open');
			this.model.$bubbleContainer = $element.find('.bubbleContainer');

			// init filter
			var value = this.model.$filterField.val();
			this.filter(value);

			// set position if necessary
			if(this.config.orientation === 'N'){
				this.model.$optionListContainer.css('margin-top', 'calc(-' + this.config.distanceY + ' - ' + (this.model.mainHeight || 0) + 'px)');
			} else {
				this.model.$optionListContainer.css('margin-top', this.config.distanceY);
			}
		}
	}
};
